/**
 * Single source of truth for the backend API base URL.
 * In production, NGINX proxies API routes on the same domain (https://laser-tags.com).
 */
const API_BASE_URL =
  import.meta.env.VITE_BACKEND_BASE_URL ||
  import.meta.env.VITE_LASER_BACKEND_BASE_URL ||
  '';

if (!API_BASE_URL && import.meta.env.PROD) {
  console.error(
    'VITE_BACKEND_BASE_URL is not set. Rebuild with .env.production before deploying.'
  );
}

export { API_BASE_URL };
